import { supabase } from '@/integrations/supabase/client';

export const setupPriceBotWebhook = async () => {
  try {
    const { data, error } = await supabase.functions.invoke('telegram-price-bot-webhook', {
      body: { action: 'setup' }
    });

    if (error) {
      console.error('Error setting up price bot webhook:', error);
      return { success: false, error: error.message };
    }

    console.log('Price bot webhook setup response:', data);
    return data;
  } catch (error) {
    console.error('Error calling webhook setup function:', error);
    return { success: false, error: error.message };
  }
};

export const checkPriceBotWebhook = async () => {
  try {
    const { data, error } = await supabase.functions.invoke('telegram-price-bot-webhook', {
      body: { action: 'check' }
    });

    if (error) {
      console.error('Error checking price bot webhook:', error);
      return { success: false, error: error.message };
    }

    console.log('Price bot webhook info:', data);
    return data;
  } catch (error) {
    console.error('Error calling webhook check function:', error);
    return { success: false, error: error.message };
  }
};